import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FinalUser } from 'src/app/models/final-user.model';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { globals } from '../utils/globals';
import { HttpService } from '../services/http-service';
import { UrlService } from '../services/url-service';
import { TransferStateService } from 'src/services/transfer-state.service';
import { TokenStorageService } from 'src/services/token-storage.service';
import { FinalUserResponse } from 'src/app/models/final-user-response.model';
import { FinalUserAudio } from 'src/app/models/final-user-audio.model';
import { DeviceDetectorService } from "src/services/device-detector.service";

@Injectable()
export class FinalUserRestService extends HttpService<FinalUser> {

  constructor(
    override _translateService: TranslateService,
    override _globals: globals,
    override _http: HttpClient,
    override _transferStateService: TransferStateService,
    private _tokenStorageService: TokenStorageService,
    private urlService: UrlService,
    private _deviceDetectorService : DeviceDetectorService,
  ) {
    super(_http, _translateService, _globals, _transferStateService);
  }

  registerNewFinalUser(data: any): Observable<FinalUser[]> {
    let url = this.urlService.getRegisterFinalUserURL();

    let postData: any = {};
    const cookies = document.cookie.split('; ')
    let beContacted = 0;
    let device = 'other';
    if (this._deviceDetectorService.isPcDevice()) {
      device = 'pc';
    }
    if (this._deviceDetectorService.isMobileDevice()) {
      device = 'mobile';
    }
    if (this._deviceDetectorService.isTabletDevice()) {
      device = 'tablet';
    }
    for (const cookie of cookies) {
      const [name, value] = cookie.split('=');
      if (name === 'beContacted') {
        beContacted = value === 'true' ? 1 : 0;
        break;
      }
    }
    postData['name'] = data.name;
    postData['email'] = data.email;
    postData['nif'] = data.nif;
    postData['telephone'] = data.telephone;
    postData['zip_code'] = data.postalCode;
    postData['id_lang'] = 1;
    postData['final_score'] = 0;
    postData['becontacted'] = beContacted;
    postData['device'] = device;
    postData['end'] = 0;
    document.cookie = `beContacted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    let header: any = {};
    header[this._globals.constants.HEADER_CONTENT_TYPE] =
      this._globals.constants.HEADER_CONTENT_TYPE_VALUE_APPLICATION_FORM_URL_ENCODED;
    return this._post(url, postData, header).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  editFinalUser(data: any, id: any): Observable<FinalUser> {
    let url = this.urlService.getUpdateFinalUserURL() + id;
    let header: any = {};
    let postData: any = {};
    postData['name'] = data.name;
    postData['email'] = data.email;
    postData['telephone'] = data.telephone;
    postData['id_lang'] = 1;
    postData['final_score'] = data.final_score;
    postData['total_time'] = data.totalTime;
    postData['end'] = data.end;
    header[this._globals.constants.HEADER_CONTENT_TYPE] =
      this._globals.constants.HEADER_CONTENT_TYPE_VALUE_APPLICATION_FORM_URL_ENCODED;
    return this._post(url, postData, header).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  addFinalUserResponse(
    finalUserId: any,
    responseId: any,
    customText?: any
  ): Observable<FinalUserResponse> {
    let url = this.urlService.getAddFinalUserResponseURL();
    let header: any = {};
    let data: any = {};
    data['final_user_id'] = finalUserId;
    data['response_id'] = responseId;
    if (customText){
      data['custom_text'] = customText;
    }
    /*
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject!.getAccessToken();
    }*/
    return this._postAttachment(url, data).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  deleteFinalUser(finalUserId: any): Observable<FinalUserResponse> {
    let url = this.urlService.getDeleteUserURL() + finalUserId;
    let header: any = {};
    let data: any = {};
    header[this._globals.constants.HEADER_CONTENT_TYPE] =
        this._globals.constants.HEADER_CONTENT_TYPE_VALUE_APPLICATION_FORM_URL_ENCODED;
    return this._http.delete(url, data).pipe(
        map((result: any) => {
          return result;
        })
    );
  }

  deleteFinalUserResponseByQuestionId(
    finalUserId: any,
    questionId: any
  ): Observable<FinalUserResponse> {
    let url = this.urlService.getDeleteFinalUserResponseByQuestionIdURL() + finalUserId + "/" + questionId;
    let header: any = {};
    let data: any = {};
    /*
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject!.getAccessToken();
    }*/
    return this._http.delete(url, data).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  addFinalUserAudio(
    finalUserId: number,
    audioPath: string
  ): Observable<FinalUserAudio> {
    let url = this.urlService.getAddFinalUserAudioURL();
    let header: any = {};
    let data: any = {};
    data['id_final_user'] = finalUserId;
    data['audio_path'] = audioPath;
    /*
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject!.getAccessToken();
    }*/
    return this._postAttachment(url, data).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  isEmailAvailable(
    email: string
  ): Observable<any> {
    let url = this.urlService.getIsEmailAvailableFinalUserURL() + '/' + email;

    let data: any = {};
    let header: any = {};

    return this._get(url, data, header).pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  isNifAvailable(
      nif: string
  ): Observable<any> {
    let url = this.urlService.getIsNifAvailableFinalUserURL() + '/' + nif;

    let data: any = {};
    let header: any = {};

    return this._get(url, data, header).pipe(
        map((result: any) => {
          return result;
        })
    );
  }

  getAllFinalUsersOrdered(page : number, perPage : number): Observable<FinalUser[]>{
    let url = this.urlService.getAllFinalUsersOrderedURL() + page + "/" + perPage;

    let data: any = {};
    let header: any = {};
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject;
    }
    return this._get(url, data, header).pipe(
      map((result: any) => {
        return result;
      })
    )
  }

  getCountUsers(): Observable<FinalUser[]> {
    let url = this.urlService.getCountAllUsers() + "/" + 0;
    let data: any = {};
    let header: any = {};
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject;
    }
    return this._get(url, data, header).pipe(
        map((result: any) => {
          return result;
        })
    )
  }

  search(input : string): Observable<FinalUser[]>{
    let url = this.urlService.getFinalUserSearchURL() + input;

    let data: any = {};
    let header: any = {};
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject;
    }
    return this._get(url, data, header).pipe(
      map((result: any) => {
        return result;
      })
    )
  }

}
